import React, { ChangeEvent } from 'react';

import Input from 'xgimi-ui/mui/material/Input';

import Base from 'xgimi-ui/BaseComponent';

import s from './.module.scss';

interface Props {
  // 最大字数
  maxSize: number;
  // placeholder
  placeholder?: string;
  // 初始值
  defaultValue?: string;
  // 输入值变化
  onChange: (value: string) => void;
  // 标签
  label?: string;
  //
  inputRef?: any;
}

interface State {
  // 输入值
  value: string;
}

/**
 * Input组件
 */
class InputBase extends Base<Props, State> {
  state: State = (() => {
    // 传入了初始值则赋值给value
    const value = this.props.defaultValue === undefined ? '' : this.props.defaultValue;
    return { value };
  })();

  constructor(props: Props) {
    super(props);
    this.watch('defaultValue', () => this.props.defaultValue as string, (defaultValue: string) => {
      this.setState({ value: defaultValue });
    });
  }

  /**
   * 输入值变化
   */
  private inputChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (event.target.value.length <= this.props.maxSize) {
      this.setState({ value: event.target.value });
      this.props.onChange(event.target.value);
    }
  };

  render(): React.ReactNode {
    return (
      <div className={s.container}>
        <div className={s.label}>{this.props.label}</div>
        <Input
          classes={{ root: s.inputContainer, input: s.input, focused: s.focused }}
          placeholder={this.props.placeholder}
          onChange={this.inputChange}
          disableUnderline={true}
          value={this.state.value}
          multiline={true}
          maxRows={8}
          inputRef={this.props.inputRef}
        />
      </div>
    );
  }
}

export default InputBase;
